module.exports = __webpack_public_path__ + "img/hand2.6b9ed17b.svg";